export const ROUTES = {
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  DASHBOARD: "/dashboard",
  SETTINGS: "/dashboard/settings",
  DILEMMAS: "/dashboard/dilemmas",
  DILEMMA_DETAILS: (id: string) => `/dashboard/dilemmas/${id}`,
  DILEMMA_CREATE: "/dashboard/dilemmas/create",
  DILEMMA_TRANSLATE: (id: string) => `/dashboard/dilemmas/${id}/translate`,
  SUBMISSION_DETAILS: (id: string) => `/dashboard/submissions/${id}`,
  SUBMISSION_CREATE: "/dashboard/submissions/create",
  SUBMISSION_TRANSLATE: (id: string) =>
    `/dashboard/submissions/${id}/translate`,
  THEMES: "/dashboard/themes",
  THEME_DETAILS: (id: string) => `/dashboard/themes/${id}`,
  THEME_CREATE: "/dashboard/themes/create",
  USERS: "/dashboard/users",
  USER_DETAILS: (id: string) => `/dashboard/users/${id}`,
  USER_CREATE: "/dashboard/users/create",
  DOCUMENTATION: "/dashboard/documentation",
  DOCUMENTATION_CREATE: "/dashboard/documentation/create",
  DOCUMENTATION_DETAILS: (id: string) => `/dashboard/documentation/${id}`,
  WARNINGS: "/dashboard/warnings",
  ALERT_CREATE: "/dashboard/warnings/create",
  ALERT_DETAILS: (id: string) => `/dashboard/warnings/${id}`,
  HISTORY: "/dashboard/history",
  ABOUT: "/dashboard/about",
  ABOUT_CREATE: "/dashboard/about/create",
  ABOUT_DETAILS: (id: string) => `/dashboard/about/${id}`,
  ACCOUNT: "/dashboard/account",
  SUBMISSIONS: "/dashboard/submissions",
};
